import { ErrorReference } from '../../types';

export const SIGNAL_TRANSACTION_NOT_INITIATED: ErrorReference = {
  server: {
    error_type: 'SIGNAL_ERROR',
    error_code: 'SIGNAL_TRANSACTION_NOT_INITIATED',
    error_message:
      'Transactions previously reported as not initiated cannot be reported as returned',
    display_message: null,
    http_code: 409,
  },
  link: null,
};

export const CLIENT_TRANSACTION_ID_ALREADY_IN_USE: ErrorReference = {
  server: {
    error_type: 'SIGNAL_ERROR',
    error_code: 'CLIENT_TRANSACTION_ID_ALREADY_IN_USE',
    error_message:
      'Client transaction id has already been used in a different transaction',
    display_message: null,
    http_code: 409,
  },
  link: null,
};

export const NOT_ENABLED_FOR_SIGNAL_TRANSACTION_SCORE_RULESETS: ErrorReference =
  {
    server: {
      error_type: 'SIGNAL_ERROR',
      error_code: 'NOT_ENABLED_FOR_SIGNAL_TRANSACTION_SCORE_RULESETS',
      error_message:
        'Your account is not enabled for Signal Transaction Score rulesets. Use a Balance-only ruleset or contact your Account Manager to enable Signal Transaction Scores.',
      display_message: null,
      http_code: 403,
    },
    link: null,
  };

export const RULESET_NOT_FOUND: ErrorReference = {
  server: {
    error_type: 'SIGNAL_ERROR',
    error_code: 'RULESET_NOT_FOUND',
    error_message:
      "Missing 'default' ruleset. Create the ruleset here: https://dashboard.plaid.com/signal/risk-profiles",
    display_message: null,
    http_code: 404,
  },
  link: null,
};

export const ADDENDUM_NOT_SIGNED: ErrorReference = {
  server: {
    error_type: 'SIGNAL_ERROR',
    error_code: 'ADDENDUM_NOT_SIGNED',
    error_message:
      'Signal Addendum has not been signed, contact your account manager to sign the addendum.',
    display_message: null,
    http_code: 403,
  },
  link: null,
};

export const INVALID_CONFIGURATION_STATE: ErrorReference = {
  server: {
    error_type: 'SIGNAL_ERROR',
    error_code: 'INVALID_CONFIGURATION_STATE',
    error_message:
      'Client configuration state is missing default ruleset imputation, contact your Account Manager for assistance.',
    display_message: null,
    http_code: 409,
  },
  link: null,
};
